import type { SVGProps } from 'react';

// 16x16 line icons, square caps, 2px strokes. Matches the hard-cornered UI.
const base: SVGProps<SVGSVGElement> = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'square',
  strokeLinejoin: 'miter',
  'aria-hidden': true,
};

export const IconSelect = () => (
  <svg {...base}>
    <path d="M3 2l10 6-4 1-2 4z" fill="currentColor" stroke="none" />
  </svg>
);
export const IconHand = () => (
  <svg {...base}>
    <path d="M5 8V3M8 7V2M11 7V3M5 8l-2 1 3 5h6l2-4V6h-3" />
  </svg>
);
export const IconNote = () => (
  <svg {...base}>
    <path d="M2 2h12v8l-4 4H2z M10 14v-4h4" />
  </svg>
);
export const IconTitle = () => (
  <svg {...base}>
    <path d="M2 3h12M8 3v11M5 14h6" />
  </svg>
);
export const IconImage = () => (
  <svg {...base}>
    <path d="M2 2h12v12H2z M2 11l4-4 3 3 2-2 3 3" />
    <rect x="10" y="4" width="2" height="2" fill="currentColor" stroke="none" />
  </svg>
);
export const IconUndo = () => (
  <svg {...base}>
    <path d="M6 3L2 7l4 4M2 7h8a4 4 0 0 1 0 8" />
  </svg>
);
export const IconRedo = () => (
  <svg {...base}>
    <path d="M10 3l4 4-4 4M14 7H6a4 4 0 0 0 0 8" />
  </svg>
);
export const IconZoomIn = () => (
  <svg {...base}>
    <path d="M7 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zM7 5v4M5 7h4M11 11l3 3" />
  </svg>
);
export const IconZoomOut = () => (
  <svg {...base}>
    <path d="M7 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zM5 7h4M11 11l3 3" />
  </svg>
);
export const IconFit = () => (
  <svg {...base}>
    <path d="M2 6V2h4M10 2h4v4M14 10v4h-4M6 14H2v-4" />
  </svg>
);
export const IconSun = () => (
  <svg {...base}>
    <path d="M8 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM8 1v2M8 13v2M1 8h2M13 8h2M3 3l1.5 1.5M11.5 11.5L13 13M3 13l1.5-1.5M11.5 4.5L13 3" />
  </svg>
);
export const IconMoon = () => (
  <svg {...base}>
    <path d="M13 10A6 6 0 0 1 6 3a6 6 0 1 0 7 7z" />
  </svg>
);
export const IconDots = () => (
  <svg {...base} stroke="none" fill="currentColor">
    <rect x="2" y="7" width="2" height="2" />
    <rect x="7" y="7" width="2" height="2" />
    <rect x="12" y="7" width="2" height="2" />
  </svg>
);
export const IconTrash = () => (
  <svg {...base}>
    <path d="M2 4h12M6 4V2h4v2M4 4l1 10h6l1-10" />
  </svg>
);
export const IconDuplicate = () => (
  <svg {...base}>
    <path d="M2 2h8v8H2z M6 6h8v8H6z" />
  </svg>
);
export const IconFront = () => (
  <svg {...base}>
    <path d="M8 14V6M5 9l3-3 3 3M3 3h10" />
  </svg>
);
export const IconBack = () => (
  <svg {...base}>
    <path d="M8 2v8M5 7l3 3 3-3M3 13h10" />
  </svg>
);
export const IconForward = () => (
  <svg {...base}>
    <path d="M8 13V4M4 8l4-4 4 4" />
  </svg>
);
export const IconBackward = () => (
  <svg {...base}>
    <path d="M8 3v9M4 8l4 4 4-4" />
  </svg>
);
export const IconClose = () => (
  <svg {...base}>
    <path d="M3 3l10 10M13 3L3 13" />
  </svg>
);
export const IconHome = () => (
  <svg {...base}>
    <path d="M2 8l6-6 6 6M4 7v7h8V7M7 14v-4h2v4" />
  </svg>
);
export const IconDownload = () => (
  <svg {...base}>
    <path d="M8 2v8M5 7l3 3 3-3M2 12v2h12v-2" />
  </svg>
);
export const IconText = () => (
  <svg {...base}>
    <path d="M2 3h12M2 7h8M2 11h12M2 15h6" strokeWidth="1.5" />
  </svg>
);
export const IconShapes = () => (
  <svg {...base}>
    <path d="M2 2h6v6H2z" />
    <circle cx="11" cy="11" r="3.5" />
  </svg>
);
export const IconPen = () => (
  <svg {...base}>
    <path d="M3 13l1-4 7-7 3 3-7 7z M9 4l3 3" />
  </svg>
);
export const IconMarker = () => (
  <svg {...base}>
    <path d="M3 10l6-6 3 3-6 6H3z M2 14h12" />
  </svg>
);
export const IconEraser = () => (
  <svg {...base}>
    <path d="M6 13L2 9l6-6 5 5-5 5z M6 13h8" />
  </svg>
);
export const IconRect = () => (
  <svg {...base}>
    <rect x="2" y="3" width="12" height="10" />
  </svg>
);
export const IconEllipse = () => (
  <svg {...base}>
    <ellipse cx="8" cy="8" rx="6" ry="4.5" />
  </svg>
);
export const IconLine = () => (
  <svg {...base}>
    <path d="M2 14L14 2" />
  </svg>
);
export const IconArrow = () => (
  <svg {...base}>
    <path d="M2 14L14 2M8 2h6v6" />
  </svg>
);
export const IconLink = () => (
  <svg {...base}>
    <path d="M7 9a3 3 0 0 0 4 0l2-2a3 3 0 0 0-4-4L8 4M9 7a3 3 0 0 0-4 0L3 9a3 3 0 0 0 4 4l1-1" />
  </svg>
);
export const IconExternal = () => (
  <svg {...base}>
    <path d="M9 2h5v5M14 2L7 9M12 9v5H2V4h5" />
  </svg>
);
export const IconBold = () => (
  <svg {...base}>
    <path d="M4 2h5a3 3 0 0 1 0 6H4zM4 8h6a3 3 0 0 1 0 6H4z" />
  </svg>
);
export const IconItalic = () => (
  <svg {...base}>
    <path d="M6 2h6M4 14h6M10 2L6 14" />
  </svg>
);
export const IconUnderline = () => (
  <svg {...base}>
    <path d="M4 2v6a4 4 0 0 0 8 0V2M3 14h10" />
  </svg>
);
export const IconStrike = () => (
  <svg {...base}>
    <path d="M2 8h12M11 4.5C10 3 9 2.5 8 2.5c-2 0-3 1-3 2.5s1.5 2 3 2.5M5 11.5c1 1.5 2 2 3 2 2 0 3-1 3-2.5" />
  </svg>
);
export const IconAlignLeft = () => (
  <svg {...base}>
    <path d="M2 3h12M2 7h8M2 11h12M2 15h8" strokeWidth="1.5" />
  </svg>
);
export const IconAlignCenter = () => (
  <svg {...base}>
    <path d="M2 3h12M4 7h8M2 11h12M4 15h8" strokeWidth="1.5" />
  </svg>
);
export const IconAlignRight = () => (
  <svg {...base}>
    <path d="M2 3h12M6 7h8M2 11h12M6 15h8" strokeWidth="1.5" />
  </svg>
);
export const IconListBullet = () => (
  <svg {...base}>
    <path d="M6 4h8M6 8h8M6 12h8" strokeWidth="1.5" />
    <rect x="2" y="3" width="2" height="2" fill="currentColor" stroke="none" />
    <rect x="2" y="7" width="2" height="2" fill="currentColor" stroke="none" />
    <rect x="2" y="11" width="2" height="2" fill="currentColor" stroke="none" />
  </svg>
);
export const IconListOrdered = () => (
  <svg {...base}>
    <path d="M7 4h7M7 8h7M7 12h7" strokeWidth="1.5" />
    <path d="M2 3h1v3M2 8h2l-2 2h2M2 11h2v3H2" strokeWidth="1" />
  </svg>
);
export const IconQuote = () => (
  <svg {...base}>
    <path d="M3 4h4v4H3zM9 4h4v4H9zM7 8c0 2-1 3-3 3M13 8c0 2-1 3-3 3" strokeWidth="1.5" />
  </svg>
);
export const IconCode = () => (
  <svg {...base}>
    <path d="M6 4L2 8l4 4M10 4l4 4-4 4" />
  </svg>
);
export const IconClear = () => (
  <svg {...base}>
    <path d="M3 3h10M8 3v8M5 14h6M11 9l3 3M14 9l-3 3" strokeWidth="1.5" />
  </svg>
);
export const IconAlignL = () => (
  <svg {...base}>
    <path d="M2 1v14M5 4h9v3H5zM5 9h5v3H5z" strokeWidth="1.5" />
  </svg>
);
export const IconAlignCX = () => (
  <svg {...base}>
    <path d="M8 1v14M3 4h10v3H3zM5 9h6v3H5z" strokeWidth="1.5" />
  </svg>
);
export const IconAlignR = () => (
  <svg {...base}>
    <path d="M14 1v14M2 4h9v3H2zM6 9h5v3H6z" strokeWidth="1.5" />
  </svg>
);
export const IconAlignT = () => (
  <svg {...base}>
    <path d="M1 2h14M4 5h3v9H4zM9 5h3v5H9z" strokeWidth="1.5" />
  </svg>
);
export const IconAlignCY = () => (
  <svg {...base}>
    <path d="M1 8h14M4 3h3v10H4zM9 5h3v6H9z" strokeWidth="1.5" />
  </svg>
);
export const IconAlignB = () => (
  <svg {...base}>
    <path d="M1 14h14M4 2h3v9H4zM9 6h3v5H9z" strokeWidth="1.5" />
  </svg>
);
export const IconDistH = () => (
  <svg {...base}>
    <path d="M1 2v12M15 2v12M5 5h2v6H5zM9 5h2v6H9z" strokeWidth="1.5" />
  </svg>
);
export const IconDistV = () => (
  <svg {...base}>
    <path d="M2 1h12M2 15h12M5 5h6v2H5zM5 9h6v2H5z" strokeWidth="1.5" />
  </svg>
);
export const IconGroup = () => (
  <svg {...base}>
    <path d="M2 2h12v12H2z" strokeDasharray="2 2" strokeWidth="1.5" />
    <path d="M5 5h3v3H5zM8 8h3v3H8z" strokeWidth="1.5" />
  </svg>
);
export const IconUngroup = () => (
  <svg {...base}>
    <path d="M2 2h5v5H2zM9 9h5v5H9z" strokeWidth="1.5" />
  </svg>
);
export const IconLock = () => (
  <svg {...base}>
    <path d="M4 7V5a4 4 0 0 1 8 0v2M3 7h10v7H3z" strokeWidth="1.5" />
  </svg>
);
export const IconUnlock = () => (
  <svg {...base}>
    <path d="M4 7V5a4 4 0 0 1 7.5-2M3 7h10v7H3z" strokeWidth="1.5" />
  </svg>
);
export const IconGrid = () => (
  <svg {...base}>
    <path d="M2 2h5v5H2zM9 2h5v5H9zM2 9h5v5H2zM9 9h5v5H9z" strokeWidth="1.5" />
  </svg>
);
export const IconMagnet = () => (
  <svg {...base}>
    <path d="M4 2v6a4 4 0 0 0 8 0V2M4 2h3v6M9 2h3v6" strokeWidth="1.5" />
  </svg>
);
export const IconPin = () => (
  <svg {...base}>
    <path d="M6 2h4v5l2 2v2H4V9l2-2zM8 11v4" strokeWidth="1.5" />
  </svg>
);
export const IconLayers = () => (
  <svg {...base}>
    <path d="M8 2l6 3-6 3-6-3zM2 8l6 3 6-3M2 11l6 3 6-3" strokeWidth="1.5" />
  </svg>
);
export const IconEye = () => (
  <svg {...base}>
    <path d="M1 8s3-5 7-5 7 5 7 5-3 5-7 5-7-5-7-5z" strokeWidth="1.5" />
    <circle cx="8" cy="8" r="2" strokeWidth="1.5" />
  </svg>
);
export const IconEyeOff = () => (
  <svg {...base}>
    <path d="M1 8s3-5 7-5 7 5 7 5-3 5-7 5-7-5-7-5zM2 2l12 12" strokeWidth="1.5" />
  </svg>
);
export const IconTable = () => (
  <svg {...base}>
    <path d="M2 3h12v10H2zM2 7h12M2 10h12M6 3v10M10 3v10" strokeWidth="1.5" />
  </svg>
);
export const IconTodo = () => (
  <svg {...base}>
    <path d="M2 3h4v4H2zM2 9h4v4H2zM8 5h6M8 11h6M3 5l1 1 2-2" strokeWidth="1.5" />
  </svg>
);
export const IconKanban = () => (
  <svg {...base}>
    <path d="M2 2h3v12H2zM6.5 2h3v8h-3zM11 2h3v5h-3z" strokeWidth="1.5" />
  </svg>
);
export const IconPaperclip = () => (
  <svg {...base}>
    <path d="M10 5L5.5 9.5a2 2 0 0 0 3 3L13 8a3.5 3.5 0 0 0-5-5L3.5 7.5" strokeWidth="1.5" />
  </svg>
);
